import React, { Fragment, useContext, useState } from 'react';
import dateFormat from "dateformat";

import { UserContext } from "../Contexts/UserContext/UserContext.js";
import { deepcopy, mult_to_percent } from '../helpers/helpers.js';
import { Slide } from "../display_wallet.js"
import { Row } from "../components/Row";
import { Spaces } from "../components/Spaces";
import ProgressBar from 'react-bootstrap/ProgressBar';
import { toFixedDown } from '../helpers/convert_bsv_tokens.js';

import { Tableau } from '../components/Tableau.js';
import SkeletonText from '../components/SkeletonText.js';
import { Alert } from 'react-bootstrap';
import ChartMintuple from '../components/ChartMintuple.js';
import { getLog } from '../helpers/helpers.js';
import CoinHeader from '../components/CoinHeader.js';
import SwitchSlider from '../components/SwitchSlider.js';


/**
 * build a first version of the mintuple table with loaders for the effects
 */
function build_multlist2d_display(newmultlist, newmultlist_timestamps) {
	var multlist2d = []

	const one_day_ms = 86400 * 1000

	/* // now useless ?
	function date_one_month_before(timestamp_ms) {
		const d = new Date(timestamp_ms)
		// move one month before
		d.setMonth(d.getMonth() - 1)
		d.setHours(0, 0, 0, 0)  // Zero the time component
		// Get the time value in milliseconds
		return d.getTime()
	}
	*/

	for (let i = 0; i < newmultlist.length; i++) {
		// we add 1 day so that if the mintuple was sent on 01/Y or 31/X it still corresponds to the same month
		// const curr_timestamp = date_one_month_before(newmultlist_timestamps[i] + one_day_ms)
		const curr_timestamp = newmultlist_timestamps[i] + one_day_ms

		// we consider the mintuple to always be sent on the first of the month (even if it was sent on 31/X at 22h)
		const i_date = "01 " + dateFormat(curr_timestamp, "mmm yyyy") //(new Date(curr_timestamp)).toLocaleString("fr-FR")

		var effect = <SkeletonText width="3em" />
		var multlist_percent = mult_to_percent(newmultlist[i]) + "%"

		multlist2d.push([i_date, multlist_percent, effect])
	}
	// reverse all to show last as first
	multlist2d = multlist2d.reverse()

	return multlist2d
}

/**
 * build the chart data based on only the mintuples
 * (not the effects, because a user might send/receive in-between mintuples and that would break the chart)
 */
function build_chart_data(multlist, multlist_timestamps) {

	let chartData = [{  // init value
		name: "création",
		// mintuple: 0,
		cumul: 0,
	}]
	var cumul = 1  // example: ((1.02*1.03*1.05)-1)*100 = 10.3%

	for (let i = 0; i < multlist.length; i++) {
		let curr_timestamp = multlist_timestamps[i]
		// let i_date = (new Date(curr_timestamp)).toLocaleString("fr-FR")
		// let i_date = dateFormat(curr_timestamp, "dd mmm yy HH:MM")
		let i_date = dateFormat(curr_timestamp, "mmm yy")

		// let multlist_percent = parseFloat(mult_to_percent(multlist[i]))
		cumul = cumul * multlist[i]

		chartData.push({
			name: i_date,
			// mintuple: parseFloat((multlist_percent).toFixed(2)),
			cumul: parseFloat(((cumul - 1) * 100).toFixed(1)),
		})
	}

	return chartData
}


/**
 * add the effect for each multiplicator
 * BEWARE for displaying the table effects we DO want to take sends/receives into account
 */
function add_effects_to_multlist2d_display(
	multlist2d, tokens_txdata, newmultlist, newmultlist_timestamps
) {
	const function_id = "add_effects_to_multlist2d_display(): "
	const log = getLog(function_id)

	// is this really sorted by old to new ? anyway it works!
	let txdata_oldtonew = tokens_txdata

	//these are already from old to new
	const multlist_oldtonew = newmultlist
	const multlist_timestamps_oldtonew = newmultlist_timestamps

	// log(" txdata_oldtonew   = ", txdata_oldtonew) // pollutes logs
	log(" multlist_oldtonew=", multlist_oldtonew, "txdata_oldtonew.length=", txdata_oldtonew.length)

	//let's keep track of things while going through multlist
	let i_history = 0
	let amount_to_date = 0
	let mult_to_date = 1.0  //mults init at 1.0
	let first_idx_applies = 0    // will say which mult is the first to apply to the wallet
	let foundfirstidxapplies = false  //necessary in case entire wallet goes to 0 and then above it again

	//TODO get from contract
	let decimalsDisplay = 2
	let decimals = 8

	// on parcours tous les mintuples en partant du plus ancien
	for (let i = 0; i < multlist_oldtonew.length; i++) {
		let str_counter = i + " / " + multlist_oldtonew.length + " "
		log(str_counter + " (amount_to_date=" + amount_to_date + ")")
		const curr_mult = multlist_oldtonew[i]
		const curr_mult_timestamp = multlist_timestamps_oldtonew[i]

		// now let's calculate how many tokens the user owned when that mintuple was published
		// by taking into account sends/receives from 'txdata_oldtonew'
		let effect = "--"  // default
		while (i_history < txdata_oldtonew.length) {
			let currtx = txdata_oldtonew[i_history]
			if (curr_mult_timestamp > currtx.timestamp) {
				if (currtx.effect_amount) {
					amount_to_date += currtx.effect_amount  // apply effect
					log(str_counter, "currtx: effect_amount=", currtx.effect_amount, "(val", currtx.effect_amount * 1e-8, ")",
						" amount_to_date=", amount_to_date, "(val", amount_to_date * 1e-8, ")",
						"  amount_to_date * mult_to_date=", amount_to_date * mult_to_date, "(val", amount_to_date * mult_to_date * 1e-8, ")",
					)
				}
			}
			else break;
			i_history++
		}
		log(str_counter, "amount_to_date=", amount_to_date)
		if (amount_to_date > 0) {
			let val_before = toFixedDown(parseFloat(amount_to_date * mult_to_date * Math.pow(10, -decimals)), decimalsDisplay)
			let mult_to_date_after = mult_to_date * curr_mult
			let val_to_date = toFixedDown(parseFloat(amount_to_date * mult_to_date_after * Math.pow(10, -decimals)), decimalsDisplay)

			effect = parseFloat(val_to_date - val_before).toFixed(decimalsDisplay)  // toFixedDown() here displayed 0.25 instead of 0.26 for 0.259999999999
			log(str_counter, "=> val_before=", val_before,
				" val_to_date=", val_to_date,
				" effet=", (val_to_date - val_before),
				" mult_to_date_after=", mult_to_date_after,
				// +"\n\t "+parseFloat(val_to_date-val_before)
				// +"\n\t "+parseFloat(val_to_date-val_before).toFixed(decimalsDisplay)
				// +"\n\t "+toFixedDown(parseFloat(val_to_date-val_before), decimalsDisplay)
			)

			if (effect >= 0) effect = "+" + effect  // minus already has "-" before it so no need to add it
		}

		// if this mult doesn't apply lets increase first_idx_applies
		if (amount_to_date === 0 && !foundfirstidxapplies) first_idx_applies++
		else foundfirstidxapplies = true

		// maintenant on peut MAJ le mult_to_date
		mult_to_date = mult_to_date * curr_mult

		// update
		multlist2d[multlist_oldtonew.length - 1 - i][2] = effect
		log("updated effect at index " + (multlist_oldtonew.length - 1 - i))
	}
	return [multlist2d, first_idx_applies]
}



export default function Slide_Multiplicators(props) {
	const userContext = useContext(UserContext)
	const classname = "Slide_Multiplicators: "

	const function_id = classname + "render(): "
	const log = getLog(function_id)

	const coinProps = userContext.get_selected_coin_props()
	// examples: coinProps.tokenid ticker .name .logo .color
	log("coinProps.tokenid=", coinProps.tokenid)

	if (coinProps.tokenid == "bsv") {
		return (
			<Slide num={props.num}>
				<center>
					<CoinHeader />
					<br /><br />
					This feature does not exist for this token.
					<br /><br />
				</center>
			</Slide>
		)
	}

	const [displayall, set_displayall] = useState(false)
	const [multlist2d, set_multlist2d] = useState(null)
	const [effectsHaveBeenSet, set_effectsHaveBeenSet] = useState(false)
	const [first_idx_applies, set_first_idx_applies] = useState(0)

	const multlist = userContext.multlist_list
	const multlist_timestamps = userContext.multlist_timestamps
	const tokens_txdata = userContext.tokens_txdata

	log("multlist = ", multlist, "\n multlist_timestamps=", multlist_timestamps)

	const changeDisplay = () => {
		set_displayall(!displayall)
	}

	const [progressbar_percent, set_progressbar_percent] = useState(null)

	const update_progress_bar = () => {
		log("update_progress_bar")
		var history_loading_progress = userContext.get_history_loading_progress()
		var _historysize = history_loading_progress.size
		var _nbloaded = history_loading_progress.nbloaded
		// let's avoid having percent=NaN
		_nbloaded = _nbloaded || 0
		_historysize = _historysize || 100
		var percent = parseInt(_nbloaded / _historysize * 100)
		set_progressbar_percent(percent)
	}

	if (progressbar_percent == null) {
		update_progress_bar()
	}

	log("progressbar_percent = ", progressbar_percent)

	if (progressbar_percent !== 100) {
		// wait for a few ms and recalculate progressbar
		setTimeout(() => {
			update_progress_bar()
		}, 500);
	}

	var progressbar =
		<ProgressBar style={{ height: "25px", fontSize: "15px" }}
			variant="success" now={progressbar_percent || 0}
			label={progressbar_percent + " %"/*nbloaded+" / "+historysize+" transactions"*/}
			animated />

	if (multlist2d == null && multlist && multlist_timestamps) {
		const new_multlist2d = build_multlist2d_display(multlist, multlist_timestamps)
		set_multlist2d(new_multlist2d)
	}

	var final_multlist2d = []
	var jsx_changeDisplayButton = null

	if (multlist2d != null) {
		if (!effectsHaveBeenSet && tokens_txdata) {
			var res = add_effects_to_multlist2d_display(
				multlist2d, tokens_txdata, multlist, multlist_timestamps
			)

			const new_multlist2d = res[0]
			const new_first_idx_applies = res[1]

			log("new_multlist2d = ", new_multlist2d, "\n\n vs multlist2d=", multlist2d)

			set_multlist2d(new_multlist2d)
			set_first_idx_applies(new_first_idx_applies)
			set_effectsHaveBeenSet(true)
		}

		if (!displayall) {
			//slice() is only a shallow copy so we need to do it ourselves
			final_multlist2d = []
			for (var i = 0; i < multlist2d.length - first_idx_applies; i++) {
				final_multlist2d.push(multlist2d[i])
			}
		} else {
			final_multlist2d = deepcopy(multlist2d)
		}

		log("multlist2d.length=", multlist2d.length, ", first_idx_applies=", first_idx_applies)

		if (effectsHaveBeenSet && first_idx_applies > 0) {
			jsx_changeDisplayButton =
				<Fragment>
					<Row style={{ display: "inline-block", float: "right" }}>
						<SwitchSlider onChange={changeDisplay} />
						&nbsp;<i>Show all mintuples</i>
					</Row>
					<br />
				</Fragment>
		}
	}

	let chartData = null
	if (multlist && multlist_timestamps) {
		chartData = build_chart_data(multlist, multlist_timestamps)
		log("chartData=", chartData)
	}

	return (
		<Slide num={props.num}>

			<center>
				<CoinHeader />
				<br />

				<h1>
					<i className="fas fa-seedling" /><Spaces count="3" />
					{coinProps.name} Mintuples
				</h1>

				<br />
				<Alert variant="light">
					<i style={{ fontSize: "25px", marginRight: "10px" }} className="fa fa-info-circle" />
					A mintuple is a creation of new, equally distributed tokens.
				</Alert>
				<br />

				{multlist2d == null ?
					<ChartMintuple loading />
					:
					<ChartMintuple data={chartData} />
				}
				<br />

				{multlist2d != null && !effectsHaveBeenSet ?
					<center>Loading...<br />{progressbar}<br /></center>
					: null}

				<Tableau
					titles={["Date", "Mintuple", <div>{coinProps.name} Effect</div>]}
					values={final_multlist2d}
					loading={multlist2d == null}
					empty_mess="No mintuple affecting your wallet at this time."
				/>
				{jsx_changeDisplayButton}
			</center>

		</Slide>
	)
}
